import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  exitPropertyWalkThroughForm,
  fetchConfigureTypeWalkThroughData,
} from '../../store/actions/propertyWalkThroughForm';
import {
  setEasyWalkThroughFormData,
  exitEasyWalkThroughForm,
  fetchWalkThroughServiceList,
  downloadPDF,
} from '../../store/actions/easyWalkThroughForm';
import { selectEasyWalkThroughFormData } from '../../store/selectors/easyWalkThroughForm';
import Form from '../Form';
import Loader from '../Loader';
import FontAwesomeIcon from '../Icon';
import ReviewTable1 from '../ReviewTable/ReviewTable1';
import Textarea from '../Textarea';
import { selectPropertyWalkThroughFormData } from '../../store/selectors/propertyWalkThroughForm';
import Avatar from '../Avatar';
import { startFormLoading, stopFormLoading } from '../../store/actions/loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { SuccessMessages } from '../../common/constants';
import { downloadDocument } from '../../helpers/DownloadDoc';
import { ToastInfo } from '../../helpers/validationHelper';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

class ReviewDeveloperWalkthrough extends Component {
  state = {
    showImages: false,
    selectedImages: [],
  };

  componentDidMount() {
    const {
      easyWalkThroughFormData,
      stopFormLoading,
      onFetchWalkThroughServiceList,
      onFetchConfigureTypeWalkThroughData,
      onSetEasyWalkThroughFormData,
      downloadPDF,
    } = this.props;
    onSetEasyWalkThroughFormData({ walkThroughServiceRequests: [] });
    downloadPDF(easyWalkThroughFormData.walkThroughId);
    onFetchConfigureTypeWalkThroughData(easyWalkThroughFormData.walkThroughId);
    onFetchWalkThroughServiceList(easyWalkThroughFormData.walkThroughId);
    stopFormLoading();
  }

  async showImages(data) {
    let selectedImage;
    if (data && data.attachment) {
      selectedImage = JSON.parse(data.attachment);
      this.setState({
        selectedImages: selectedImage,
        showImages: true,
        selectedIndex: 0,
      });
    }
  }

  displayImages() {
    const { showImages, selectedImages, selectedIndex } = this.state;

    return (
      <ReusableLightbox
        isOpen={showImages}
        onClose={() => this.setState({ showImages: false })}
        images={selectedImages}
        initialIndex={selectedIndex}
        onIndexChange={(index) => this.setState({ selectedIndex: index })}
      />
    );
  }

  checkAttachment(data) {
    if (data && data.attachment) {
      let attachment = data.attachment.split('/');
      return attachment.length > 0 ? true : false;
    }
  }

  exportPDF = (pdfurl) => {
    ToastInfo(SuccessMessages.pdfDownloadNotification);
    downloadDocument(pdfurl);
  };

  render() {
    const {
      onExitPropertyWalkThroughForm,
      onExitEasyWalkThroughForm,
      easyWalkThroughFormData,
      propertyWalkThroughFormData,
      pdfLoader,
    } = this.props;
    const { showImages } = this.state;
    let serviceRequests =
      easyWalkThroughFormData.walkThroughServiceRequests &&
      easyWalkThroughFormData.walkThroughServiceRequests.length > 0
        ? easyWalkThroughFormData.walkThroughServiceRequests
        : [];
    let loading =
      easyWalkThroughFormData.reviewWalkThroughServiceRequestListLoading &&
      easyWalkThroughFormData.reviewWalkThroughServiceRequestListLoading ===
        true
        ? true
        : false;
    return (
      <>
        <Form
          headline={'Walk Through Review & Confirmation'}
          strapline={''}
          onClose={() => {
            onExitEasyWalkThroughForm();
            onExitPropertyWalkThroughForm();
          }}
          component={
            loading ? (
              <>
                <div style={{ justifyContent: 'center', alignItems: 'center' }}>
                  <Loader center={true} />
                </div>
              </>
            ) : (
              <>
                {pdfLoader && <Loader center={true} />}
                {easyWalkThroughFormData && easyWalkThroughFormData.PDFURL && (
                  <div style={{ textAlign: 'right' }}>
                    <FontAwesomeIcon glyph="download" weight="light" />
                    <a
                      target="blank"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        this.exportPDF(easyWalkThroughFormData.PDFURL)
                      }
                    >
                      {' '}
                      Export to PDF
                    </a>
                  </div>
                )}
                <div className="offlineWalkthroughData__listView">
                  {serviceRequests && serviceRequests.length > 0 ? (
                    <ReviewTable1
                      columns={[
                        {
                          xsHide: true,
                          label: 'Location',
                          cell: (data) =>
                            data.area && data.area.name
                              ? data.area.name
                              : data.areaName
                                ? data.areaName
                                : '',
                        },
                        {
                          xsHide: true,
                          label: 'Item',
                          cell: (data) => {
                            return data && data.itemName
                              ? data.itemName
                              : data &&
                                  data.asset &&
                                  data.asset.item &&
                                  data.asset.item.name
                                ? data.asset.item.name
                                : '';
                          },
                        },
                        {
                          xsHide: true,
                          label: 'Issue Type',
                          cell: (data) =>
                            data.serviceType
                              ? data.serviceType
                              : data.issueType && data.issueType.name
                                ? data.issueType.name
                                : data.issueType
                                  ? data.issueType
                                  : '',
                        },
                        {
                          label: 'Description',
                          cell: (data) => data.description,
                        },
                        {
                          label: <FontAwesomeIcon glyph="paperclip" weight="light" />,
                          cell: (data) => (
                            <>
                              {this.checkAttachment(data) ? (
                                <div onClick={() => this.showImages(data)}>
                                  <Avatar
                                    badge={
                                      JSON.parse(data.attachment).length > 1
                                        ? 'count'
                                        : ''
                                    }
                                    url={JSON.parse(data.attachment)[0]}
                                  />
                                </div>
                              ) : null}
                            </>
                          ),
                        },
                      ]}
                      data={serviceRequests}
                    />
                  ) : null}
                </div>
                <div style={{ marginTop: 20 }}>
                  <Textarea
                    value={
                      propertyWalkThroughFormData.configTypeSaved &&
                      propertyWalkThroughFormData.configTypeSaved.notes
                        ? propertyWalkThroughFormData.configTypeSaved.notes
                        : easyWalkThroughFormData &&
                            easyWalkThroughFormData.notes
                          ? easyWalkThroughFormData.notes
                          : ''
                    }
                    label="Notes"
                    placeholder="Notes"
                    disabled={true}
                    block
                  />
                </div>

                {showImages === true ? <>{this.displayImages()}</> : null}
              </>
            )
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    propertyWalkThroughFormData: selectPropertyWalkThroughFormData(state),
    easyWalkThroughFormData: selectEasyWalkThroughFormData(state),
    pdfLoader: selectFormLoader(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchConfigureTypeWalkThroughData: fetchConfigureTypeWalkThroughData,
      onExitEasyWalkThroughForm: exitEasyWalkThroughForm,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onFetchWalkThroughServiceList: fetchWalkThroughServiceList,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      startFormLoading,
      stopFormLoading,
      downloadPDF: downloadPDF,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewDeveloperWalkthrough);
